// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lawyer Info Tab Styles */
.lawyer-info-tab {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.edit-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: background-color 0.2s;
}

.edit-btn:hover {
  background: #0056b3;
}

/* Tip Message */
.tip-message {
  background: #e3f2fd;
  border: 1px solid #bbdefb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.tip-icon {
  font-size: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}

.tip-content {
  flex: 1 1;
}

.tip-content strong {
  color: #1976d2;
}

.tip-content p {
  margin: 0;
  color: #1976d2;
  line-height: 1.5;
  font-size: 14px;
}

/* Info Display */
.lawyer-info-display h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
}

.info-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.info-section h4 {
  margin: 0 0 16px 0;
  color: #495057;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 8px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 8px 0;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item label {
  font-weight: 600;
  color: #6c757d;
  min-width: 120px;
  flex-shrink: 0;
}

.info-item span {
  color: #333;
  text-align: right;
  flex: 1 1;
  margin-left: 16px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-state h3 {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 20px;
  font-weight: 600;
}

.empty-state p {
  margin: 0 0 24px 0;
  color: #6c757d;
  line-height: 1.5;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.add-info-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-info-btn:hover {
  background: #218838;
}

/* Loading State */
.loading {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-size: 16px;
}

/* Branding section: profile photo + firm logo */
.branding-section {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.branding-avatar-block,
.branding-logo-block {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.branding-label {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.branding-avatar-preview,
.branding-logo-preview {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.branding-avatar-image {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e5e7eb;
}

.branding-avatar-placeholder {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  color: #374151;
  font-weight: 600;
  font-size: 20px;
}

.branding-logo-image {
  max-width: 150px;
  max-height: 60px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
}

.branding-logo-placeholder {
  min-width: 150px;
  min-height: 48px;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px dashed #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  color: #6b7280;
  font-size: 14px;
}

.branding-upload-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.branding-upload-button:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.branding-upload-button input[type="file"] {
  display: none;
}

.branding-button-group {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.branding-remove-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #fecaca;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.branding-remove-button:hover:not(:disabled) {
  background: #fecaca;
  border-color: #fca5a5;
}

.branding-remove-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.branding-upload-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .lawyer-info-tab {
    padding: 16px;
  }

  .tab-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .info-item {
    flex-direction: column;
    gap: 4px;
  }

  .info-item label {
    min-width: auto;
  }

  .info-item span {
    text-align: left;
    margin-left: 0;
  }

  .branding-section {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LawyerInfoTab.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAO;EACP,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Lawyer Info Tab Styles */\n.lawyer-info-tab {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.tab-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.edit-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.edit-btn:hover {\n  background: #0056b3;\n}\n\n/* Tip Message */\n.tip-message {\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 24px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.tip-icon {\n  font-size: 20px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.tip-content {\n  flex: 1;\n}\n\n.tip-content strong {\n  color: #1976d2;\n}\n\n.tip-content p {\n  margin: 0;\n  color: #1976d2;\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n/* Info Display */\n.lawyer-info-display h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 24px;\n}\n\n.info-section {\n  background: #f8f9fa;\n  padding: 20px;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.info-section h4 {\n  margin: 0 0 16px 0;\n  color: #495057;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 8px;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding: 8px 0;\n}\n\n.info-item:last-child {\n  margin-bottom: 0;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: #6c757d;\n  min-width: 120px;\n  flex-shrink: 0;\n}\n\n.info-item span {\n  color: #333;\n  text-align: right;\n  flex: 1;\n  margin-left: 16px;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px dashed #dee2e6;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  margin: 0 0 12px 0;\n  color: #495057;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.empty-state p {\n  margin: 0 0 24px 0;\n  color: #6c757d;\n  line-height: 1.5;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.add-info-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-info-btn:hover {\n  background: #218838;\n}\n\n/* Loading State */\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n/* Branding section: profile photo + firm logo */\n.branding-section {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.branding-avatar-block,\n.branding-logo-block {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.branding-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.branding-avatar-preview,\n.branding-logo-preview {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.branding-avatar-image {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #e5e7eb;\n}\n\n.branding-avatar-placeholder {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e5e7eb;\n  color: #374151;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.branding-logo-image {\n  max-width: 150px;\n  max-height: 60px;\n  object-fit: contain;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n.branding-logo-placeholder {\n  min-width: 150px;\n  min-height: 48px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px dashed #d1d5db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f9fafb;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.branding-upload-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 8px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid #e5e7eb;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.branding-upload-button:hover {\n  background: #e5e7eb;\n  border-color: #d1d5db;\n}\n\n.branding-upload-button input[type=\"file\"] {\n  display: none;\n}\n\n.branding-button-group {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.branding-remove-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid #fecaca;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.branding-remove-button:hover:not(:disabled) {\n  background: #fecaca;\n  border-color: #fca5a5;\n}\n\n.branding-remove-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.branding-upload-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .lawyer-info-tab {\n    padding: 16px;\n  }\n\n  .tab-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .info-item {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .info-item label {\n    min-width: auto;\n  }\n\n  .info-item span {\n    text-align: left;\n    margin-left: 0;\n  }\n\n  .branding-section {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
